import React from "react";

function TableIndividu({title,underlying, nilaiPinjaman, bunga, biayaLayanan, tenor, pembayaranPokok, pembayaranBunga}){
    return (
        <div className='table-individu'>
            <table>
                <thead>
                    <tr>
                        <th><span>Tipe Pinjaman&emsp;</span><div dangerouslySetInnerHTML={{__html: title}}/></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        {title === 'Kredit Multiguna' ? <td>Agunan</td> : <td>Underlying</td>}
                        <td>{underlying}</td>
                    </tr>
                    <tr>
                        <td>Kisaran Nilai Pinjaman</td>
                        <td>{nilaiPinjaman}</td>
                    </tr>
                    <tr>
                        <td>Bunga</td>
                        <td>{bunga}</td>
                    </tr>
                    <tr>
                        <td>Biaya Layanan</td>
                        <td>{biayaLayanan}</td>
                    </tr>
                    <tr>
                        <td>Tenor Pinjaman</td>
                        <td>{tenor}</td>
                    </tr>
                    <tr>
                        <td>Pembayaran Pokok Pinjaman</td>
                        <td>{pembayaranPokok}</td>
                    </tr>
                    <tr>
                        <td>Pembayaran Bunga</td>
                        <td>{pembayaranBunga}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

function TableProduktif({title, angunan, underlying, nilaiPinjaman, bunga, biayaProvisi, biayaAdministrasi, biayaFidusia, jangkaWaktu, tenor, skemaPembayaran}){
    return (
        <div className='table-produktif'>
            <table>
                <thead>
                <tr>
                    <th><span>Tipe Pinjaman&emsp;</span><div dangerouslySetInnerHTML={{__html: title}}/></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Agunan</td>
                    <td>{angunan}</td>
                </tr>
                <tr>
                    <td>Underlying</td>
                    <td>{underlying}</td>
                </tr>
                <tr>
                    <td>Kisaran Nilai Pinjaman</td>
                    <td>{nilaiPinjaman}</td>
                </tr>
                <tr>
                    <td>Bunga</td>
                    <td>{bunga}</td>
                </tr>
                <tr>
                    <td>Biaya Provisi</td>
                    <td>{biayaProvisi}</td>
                </tr>
                <tr>
                    <td>Biaya Administrasi</td>
                    <td>{biayaAdministrasi}</td>
                </tr>
                <tr>
                    <td>Pengikatan Fidusia</td>
                    <td>{biayaFidusia}</td>
                </tr>
                <tr>
                    <td>Jangka Waktu Fasilitas</td>
                    <td>{jangkaWaktu}</td>
                </tr>
                <tr>
                    <td>Tenor per Pencairan</td>
                    <td>{tenor}</td>
                </tr>
                <tr>
                    <td>Skema Pembayaran</td>
                    <td>{skemaPembayaran}</td>
                </tr>
                </tbody>
            </table>
        </div>
    );
}

export default function Table({type, title}) {
    return (
        <div className="container-alur">
            {type === 'individu'
                ? title === 'kasbon'
                    ? <TableIndividu
                        title='Kasbon <em>(Emergency Loan)</em>'
                        underlying='Slip Gaji'
                        nilaiPinjaman='Rp 1 - 2 Juta'
                        bunga='0%'
                        biayaLayanan='Rp 75.000'
                        tenor='1 bulan'
                        pembayaranPokok='Bulanan'
                        pembayaranBunga='Bulanan'
                    />
                    : title === 'kmg'
                        ? <TableIndividu
                            title='Kredit Multiguna'
                            underlying='Sertifikat Tanah / Rumah'
                            nilaiPinjaman='Rp 100 Juta - 1 Milyar'
                            bunga='24% p.a'
                            biayaLayanan='4 - 5%'
                            tenor='12 - 120 bulan'
                            pembayaranPokok='Bulanan'
                            pembayaranBunga='Bulanan'
                        />
                        : <TableIndividu
                            title='Pinjaman Karyawan'
                            underlying='Slip Gaji'
                            nilaiPinjaman='Rp 3 - 30 juta'
                            bunga='2.19% flat perbulan'
                            biayaLayanan='5 - 7%'
                            tenor='3 - 24 bulan'
                            pembayaranPokok='Bulanan'
                            pembayaranBunga='Bulanan'
                        />
                : title === "invoice"
                    ? <TableProduktif
                        title='<em>Invoice Financing</em>'
                        angunan='Invoice/faktur yang dibiayai, Cek Mundur, Personal/Corporate Guarantee'
                        underlying='Invoice receipt, SPK, Faktur pajak, Dokumen penagihan lainnya'
                        nilaiPinjaman='Rp 500 Juta - 2 Milyar'
                        bunga='24% p.a'
                        biayaProvisi='4.5% p.a'
                        biayaFidusia='Rp 3 Juta'
                        biayaAdministrasi='0.5% p.m'
                        jangkaWaktu='1 tahun'
                        tenor='30 - 180 hari'
                        skemaPembayaran='Baloon payment'
                    />
                    : title === 'inventory'
                        ? <TableProduktif
                            title='<em>Inventory Financing</em>'
                            angunan='Persediaan/inventory yang dibiayai, Personal/Corporate Guarantee'
                            underlying='Tanda terima inventory, Daftar inventory jaminan, Surat konfirmasi penyimpanan barang'
                            nilaiPinjaman='Rp 500 Juta - 2 Milyar'
                            bunga='24% p.a'
                            biayaProvisi='0.5% p.a'
                            biayaFidusia='Rp 3 Juta'
                            biayaAdministrasi='4.5% p.m'
                            jangkaWaktu=' 1 tahun'
                            tenor='30 - 90 hari'
                            skemaPembayaran='Baloon payment'
                        />
                        : <TableProduktif
                            title='<em>Developer Financing</em>'
                            angunan='Sertifikat (SHM/SHGB), Cek Mundur, Personal/Corporate Guarantee'
                            underlying='RAB pembangunan atau invoice dari kontraktor'
                            nilaiPinjaman='Rp 500 Juta - 2 Milyar'
                            bunga='24% p.a'
                            biayaProvisi='4.5% p.a'
                            biayaFidusia='Biaya APHT'
                            biayaAdministrasi='0.5% p.m'
                            jangkaWaktu='1 - 2 tahun'
                            tenor='Maksimal 2 tahun'
                            skemaPembayaran='Monthly installment'
                        />
            }
        </div>
    );
}